import Config from '../config/constants';
import Configuration from '../model/Configuration';
import AnalyticsData from '../model/AnalyticsData';
import { ContentType, EventType } from '../model/enums';
import BaseAnalyticsData from '../model/BaseAnalyticsData';

const recordEventType = async (
    details: BaseAnalyticsData | null,
    eventType: EventType,
    contentType: ContentType,
) => {
    if (details) {
        let data: AnalyticsData = {
            contentId: details.contentId,
            contentType: contentType,
            contentTypeId: details.contentTypeId,
            eventType: eventType,
            title: details.title,
        };
        await recordEvent(data);
    }
};

const recordEvent = async (event: AnalyticsData, config?: Configuration): Promise<boolean> => {
    const resolvedConfig = config ?? retrieveSessionConfiguration();
    if (
        resolvedConfig &&
        resolvedConfig.jwt &&
        resolvedConfig.sessionId &&
        resolvedConfig.patientIdentifier &&
        resolvedConfig.tenantId
    ) {
        const now = new Date();
        let data: AnalyticsData = {
            contentId: event.contentId,
            contentType: event.contentType,
            contentTypeId: event.contentTypeId,
            eventTimestamp: now.toISOString(),
            eventType: event.eventType,
            patientId: resolvedConfig.patientIdentifier,
            sessionId: resolvedConfig.sessionId,
            tenantId: resolvedConfig.tenantId,
            title: event.title,
        };
        if (event.contentType === ContentType.Video && event.eventType === EventType.Navigation) {
            data.percentViewed = event.percentViewed;
            data.totalLengthSecond = event.totalLengthSecond;
            data.viewSegmentStart = event.viewSegmentStart;
            data.viewSegmentStop = event.viewSegmentStop;
        }

        const bearer = 'Bearer ' + resolvedConfig.jwt;
        const response = await fetch(Config.ANALYTICS_BASE_URL, {
            method: 'POST',
            body: JSON.stringify(data),
            headers: {
                Accept: 'application/json',
                Authorization: bearer,
                'Content-Type': 'application/json',
            },
        });

        return response.ok;
    }
    return false;
};

const retrieveSessionConfiguration = function (): Configuration {
    return getSessionStorageObject(Config.LOCAL_CONFIGURATION) as Configuration;
};

const getSessionStorageObject = function (key: string): any {
    const object = window.sessionStorage.getItem(key);
    return object && JSON.parse(object);
};

const services = {
    recordEventType,
    recordEvent,
};

export default services;
